import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import * as firebase from 'firebase'

/**
 * Receives sessionid, and
 * title props from AdminSessionContainer
 *
 * This component deals with
 * watching, editing, dealing
 * with student stats and deleting
 * a session
 */
class AdminSession extends Component {
  constructor (props) {
    super(props)
    this.state = {
      ready: false,
      editing: false,
      text: '',
      statsViewable: false
    }
    this.db = props.db;
    this.edit = this.edit.bind(this)
    this.deleteSession = this.deleteSession.bind(this)
    this.joinSession = this.joinSession.bind(this)
    this.handleKeyUp = this.handleKeyUp.bind(this)
    this.save = this.save.bind(this)
    this.changeSolo = this.changeSolo.bind(this)
    this.restrictStatsPage = this.restrictStatsPage.bind(this);


  }

  componentWillMount = () =>{
    let stateRef = this.db.child('Sessions').child(this.props.sessionid).child('StartSim');

    let that = this;

    stateRef.on('value', ss =>{
      // alert(props.user.uid == props.creator);
      let data = ss.val();
      let state = false;
      if (!!data){
        state = ss.val().State;
      }
      if((!!state) || (this.props.user.uid == this.props.creator)){
        that.setState({statsViewable: true}) ;
      }
      else{
        that.setState({statsViewable: false}) ;
      }
    });
  }
  /**
   *  handles "enter" for changing title
   * @param event
   */
  handleKeyUp = (event) => {
    console.log('AdminSession handleKeyUp ', event)
    if (event.key === 'Enter') {
      var val = this.refs.newTitle.value
      //alert(val)
      var newTitle = val //this.refs.newTitle.innerHTML;
      const titleRef = this.db.child('Sessions').child(this.props.sessionid).child('Info').child('Title')
      const playableRef = this.db.child('PlayableSessions').child(this.props.sessionid).child('Title')
      titleRef.set(newTitle)
      playableRef.set(newTitle)
      this.setState({
        // ** Update "text" property with new value (this fires render() again)
        editing: false
      })
    }
  }

  changeSolo = (event) => {
    console.log('AdminSession changeSolo ', event)
    const soloRef = this.db.child('PlayableSessions').child(this.props.sessionid).child('Solo')
    //const soloRef = firebase.database().ref().child(this.props.institution).child("Sessions").child(this.props.sessionid).child("Info").child("Solo");
    soloRef.once('value', snap => {
      soloRef.set(!snap.val())
    })
  }

  toggleMode () {

    let am = this.props.auctionMode;
    let dm = this.props.dealerMode;

    if (am == 0 && dm == 0){
      am = 1;
      dm = 0;
    } else if (am == 1){
      am = 0;
      dm = 0;//1
    } else if (dm == 1){
      dm = 0;
      am = 0;
    }

    const auctionRef = this.db.child('PlayableSessions').child(this.props.sessionid).child('AuctionMode');
    const dealerRef = this.db.child('PlayableSessions').child(this.props.sessionid).child('DealerMode');
    auctionRef.set(am);
    dealerRef.set(dm);
    //const soloRef = firebase.database().ref().child(this.props.institution).child("Sessions").child(this.props.sessionid).child("Info").child("Solo");
    // auctionRef.once('value', snap => {
    //   let thestate = snap.val();
    //   auctionRef.set(!!thestate ? 0 : 1);
    // })
  }

  joinSession () {
    console.log('AdminSession joinSession',this.db);
    const UserPendingRef = this.db.child('Sessions').child(this.props.sessionid).child('UsersPending').child(this.props.user.uid)
    let user = {
      uid: this.props.user.uid,
      displayName: this.props.user.displayName
    }
    UserPendingRef.update(JSON.parse(JSON.stringify(user)))
  }

  /**
   * deletes session from Sessions and PlayableSessions
   */
  deleteSession () {
    //console.log("AdminSession deleteSession");
    const SessionIDRef = this.db.child('Sessions').child(this.props.sessionid)
    SessionIDRef.remove()
    const playableRef = this.db.child('PlayableSessions').child(this.props.sessionid)
    playableRef.remove()
    this.props.deleteme(this.props.sessionid);
  }

  /**
   * disables Stats button if you are not the creator
   * or the game is still in session
   */

  restrictStatsPage(){
    return !this.state.statsViewable;
  }

  /**
   * will route to Home page based on whether restrictStatsPage()
   * is true or false
   */

  disableStatsLink = () =>{
    // alert(this.restrictStatsPage);
    return !this.state.statsViewable ? `/Home` : `/Stats`
    }

  /**
   * allows user to edit title
   */
  edit () {
    //console.log("AdminSession edit");
    this.setState({
      editing: true
    })
  }

  /**
   * handles saving title using the save button
   */
  save () {
    //console.log("AdminSession save");
    var val = this.refs.newTitle.value
    //alert(val)
    var newTitle = val //this.refs.newTitle.innerHTML;
    const titleRef = this.db.child('Sessions').child(this.props.sessionid).child('Info').child('Title')
    const playableRef = this.db.child('PlayableSessions').child(this.props.sessionid).child('Title')
    titleRef.set(newTitle)
    playableRef.set(newTitle)
    this.setState({
      // ** Update "text" property with new value (this fires render() again)
      editing: false
    })
  }

  /**
   * this render is called when not editing
   * @returns {*}
   */
  renderNormal () {
    const loadedBool = true
    //console.log("AdminSession renderNormal");
    console.log(this.props);
    var renderMode = function(){
      if (this.props.auctionMode){
        return (<span>
          <i className="fa fa-balance-scale fa-2x"/>
          <span> Call Auction </span>
         </span>
        )
      }
      if (this.props.dealerMode){
        return (<span>
          <i className="fa fa-building fa-2x"/>
          <span> Dealer Market</span>
        </span>);
      }
      return (<span>
        <i className="fa fa-book fa-2x"/>
        <span> Order Book</span>
      </span>);
    }
    // alert(this.state.statsViewable);
    return (
      <tr className={(this.props.user.uid !== this.props.creator ? '' : 'mySession')}>
        <td ref="newTitle">
          {this.props.title}
        </td>
        <td>
          <Link to={{pathname: '/Simulation', state: {sessionid: this.props.sessionid, dbi: this.props.dbi, dealerMode: this.props.dealerMode, solo: this.props.solo, creator: this.props.creator}}}>
            <button
              disabled={!!(this.props.solo && this.props.user.uid !== this.props.creator)}
              onClick={this.joinSession}>
              <i className="fa fa-sign-in fa-2x"/>
            </button>
          </Link>
        </td>
        <td>
          <Link to={{pathname: this.disableStatsLink(), state: {sessionid: this.props.sessionid,  dbi: this.props.dbi, dealerMode: this.props.dealerMode}}}>
            <button
            disabled={!this.state.statsViewable}
            >
              <i className="fa fa-list-ol fa-2x"/>
            </button>
          </Link>
        </td>
        <td>
          <button
            disabled={this.props.user.uid !== this.props.creator}
            onClick={this.toggleMode.bind(this)}>
            { renderMode.call(this) }
          </button>
        </td>
        <td>
          <button
            disabled={this.props.user.uid !== this.props.creator}
            onClick={this.edit}>
            <i className="fa fa-edit fa-2x"/>
          </button>
        </td>
        <td>
          <button
            className="deleteButton"
            disabled={this.props.user.uid !== this.props.creator}
            onClick={this.deleteSession}>
            <i className="fa fa-trash fa-2x"/>
          </button>
        </td>

        <td>
          {this.props.solo ? <i className="fa fa-user fa-2x"/> : <i className="fa fa-users fa-2x"/>}
        </td>
      </tr>
    )
  }

  /**
   * this render is called when editing
   * @returns {*}
   */
  renderForm () {
    //console.log("AdminSession renderForm");
    return (
      <div style={{'marginLeft': '15px'}} className='row'>
        <div className='col-xs-5'>
          <input onKeyUp={this.handleKeyUp} type='text' className='form-control mb-2 mr-sm-2 mb-sm-0'
                 ref="newTitle" defaultValue={this.props.title}/>
        </div>
        <div className='col-xs-2'>
          <button className='btn btn-default' onClick={this.save}>Save</button>
        </div>
        <br/>
      </div>
    )
  }

  /**
   * conditionally renders based on editing
   * @returns {*}
   */
  render () {
    //console.log("AdminSession render");
    if (this.state.editing) {
      return this.renderForm()
    } else {
      return this.renderNormal()
    }
  }
}

AdminSession.propTypes = {
  sessionid: PropTypes.string,
  title: PropTypes.string
}

export default AdminSession



// WEBPACK FOOTER //
// ./src/components/Dashboard/Session.js